<template>
  <section id="home">
    <div class="container">
      <div class="text-content-wrapper">
        <h1>Welcome to Jwayelani</h1>
        <p>Jwayelani is a local supermarket chain and trusted supplier to the various communities we serve. Jwayelani was acquired by Kind Investments in April 2019. We are still trading as your beloved Jwayelani, with skilful staff, top-quality products, and several stores nationwide to help you save more whilst creating an enjoyable shopping experience with every visit.</p>

        <!--<div class="facebook-posts-container">
          <h2>Jwayelani on Facebook</h2>

          <div class="facebook-posts-wrapper">
            <ul class="facebook-posts row">
              <li class="col-sm-6 col-md-4 col-lg-3" v-for="post in facebookPosts" v-if="post.imageUrl && post.message">
                <div class="post-wrapper">
                  <a :href="post.link" target="_blank" >
                    <img :src="post.imageUrl" alt="">
                  </a>
                  <p>{{post.message}}</p>
                  <span class="posted">{{ post.created_time | moment('from', 'now') }}</span>

                  <a :href="post.link" target="_blank" class="icon-wrapper">
                    <icon name="facebook-f" class="facebook-f-icon"></icon>
                  </a>
                </div>
              </li>
            </ul>
          </div>

        </div>-->
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'landing',
  created: function () {
    /*this.$http.get('http://jwayelani.13th.co.za:3000/latest_facebook_posts').then(function (response) {
      console.log(response)

      this.$data.facebookPosts = response.body
    }, function (error) {
      console.log(error)
    })*/
  },
  data: function () {
    return {
      facebookPosts: []
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../scss/colours';
  @import '../scss/mixins';

  section{
    padding-top: 2em;
  }

  .facebook-posts-container{
    margin-top: 3em;
  }

  .facebook-posts-wrapper{
    margin: 0 -15px;
  }

  ul.facebook-posts{
    list-style: none;
    margin: 1.5em 0;
    padding: 0;
    width: 100%;

    li{
      float: left;
      width: 100%;
      margin-bottom: 2em;

      a{
        position: relative;
        display: block;

        &:hover{
          p{
            text-decoration: none;
          }
        }
      }
    }

    .post-wrapper{
      position: relative;
      background-color: darken(white, 7.5%);
    }

    .icon-wrapper{
      position: absolute;
      width: 30px;
      height: 30px;
      right: 0px;
      bottom: 0px;
      background-color: $blue;
    }

    .facebook-f-icon{
      margin: 5px 8px;
      opacity: 1;
      width: auto;
      height: 1.5em;
      color: white;
    }

    .posted{
      position: absolute;
      left: 20px;
      bottom: 15px;
      font-size: 0.8em;
      color: #999;
    }

    img{
      width: 100%;
      margin-bottom: 1em;
    }

    p{
      line-height: 1.4em;
      padding: 0 20px 40px 20px;
      color: black;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue